import { useQuery } from '@tanstack/react-query';
import { Dialog } from '@/components-new/Dialog/Dialog';
import { DialogButtons } from '@/components-new/Dialog/styles';
import { ButtonNew } from '@/components-new/ButtonNew/ButtonNew';
import { Box } from '@/components/Box/Box';
import { AuditEventType } from '@/types/auditLogTypes';
import { useReplaceSearchParams } from '@/hooks/useReplaceSearchParams';
import { AUDIT_LOG_QUERY_KEYS, loadAuditEvent } from '../api/api';
import { getAuditLogEventDetailsPath } from '../_AuditLogEventDetailsPage/path/path';
import { AuditEventDetailsWidget } from './AuditEventDetailsWidget';
import { AuditEventChangedFields } from './AuditEventChangedFields';
import { useStatefulNavigation } from '@/hooks/useStatefulNavigation';

type AuditEventDetailsModalType = {
  isOpen: boolean;
  event: AuditEventType;
  onClose: () => void;
};

export const AuditEventDetailsModal = ({ isOpen, event, onClose }: AuditEventDetailsModalType) => {
  const { navigateFrom } = useStatefulNavigation();
  const { replaceSearchParams } = useReplaceSearchParams<{ request_id?: string; category?: string; q?: string }>();
  const { data, isPending } = useQuery({
    queryKey: [AUDIT_LOG_QUERY_KEYS.event, event.id],
    queryFn: () => loadAuditEvent(event.id),
  });
  const details = data?.body;

  const showWholeRequest = () => {
    onClose();
    replaceSearchParams({ request_id: event.request_id, category: null, q: null, page: null });
  };

  const navigateToDetails = () => {
    navigateFrom(getAuditLogEventDetailsPath(event.id));
  };

  return (
    <Dialog isOpen={isOpen} header='Audit event' width='800px' onClose={onClose}>
      <AuditEventDetailsWidget event={event} isLoading={isPending} details={details} />
      <AuditEventChangedFields details={details} />

      <DialogButtons>
        <Box marginRight='auto'>
          <ButtonNew variant='secondary' onClick={navigateToDetails}>
            View Full
          </ButtonNew>
        </Box>
        {event.request_id && (
          <ButtonNew variant='secondary' onClick={showWholeRequest}>
            Show everything from this action
          </ButtonNew>
        )}
        <ButtonNew onClick={onClose}>Close</ButtonNew>
      </DialogButtons>
    </Dialog>
  );
};
